import Tin from './Tin'
import { isPlainObject } from '../utils/assist'

// 数据缓存类，以vue-route为单位
function DataCache(options) {
	this.init(options)
}

// meta option
var defaultCache = {
	defaultVal: null, // 默认值
	expire: 0, // 到期时间/s，0=永久
	query: false, // 是否区分查询字符串
	user: true, // 是否区分用户
}

Object.assign(DataCache.prototype, {
	init(options = {}) {
		// props
		this.options = Object.assign({}, DataCache.options, options)

		this._cache = this.normalizeCache(options.cache)
		// 完整的命名空间为：插件key_路由key_主键key
		this._path = options.path || '/'
		// query以及user影响主键key的计算
		this._query = options.query || ''
		// tin代表缓存对象
		this._tins = {}

		// cache
		Object.keys(this._cache).forEach(key => {
			var config = this._cache[key]

			// init tins
			this._tins[key] = new Tin({
				key,
				defaultVal: config.defaultVal,
				path: this._path,
				expire: config.expire,
				query: config.query ? this._query : '',
				userId: config.user ? this.options.resolveUserId() : '',
			})

			// expose getters
			Object.defineProperty(this, key, {
				enumerable: true,
				configurable: true,
				get: this.createCacheGetter(key),
				set: this.createCacheSetter(key),
			})
		})
	},

	// like vue props
	normalizeCache(cache) {
		var result = {}

		// [key1, key2]
		if (Array.isArray(cache)) {
			cache.forEach(v => {
				result[v] = Object.assign({}, defaultCache)
			})
		}

		// {key1: ..., key2: ...}
		if (isPlainObject(cache)) {
			Object.keys(cache).forEach(k => {
				var v = cache[k]

				// [key1: expireTime, key2: expireTime]
				if (typeof v == "number") {
					result[k] = Object.assign({}, defaultCache)
					result[k].expire = v > 0 ? v : 0
				}

				// [key1: config, key2: config]
				if (isPlainObject(v)) {
					result[k] = Object.assign({}, defaultCache, v)
				}
			})
		}

		return result
	},

	createCacheGetter(key) {
		var tin = this._tins[key]

		return function() {
			return tin.value
		}
	},

	createCacheSetter(key) {
		var tin = this._tins[key]

		return function(val) {
			return tin.update(val)
		}
	},

	// 更新缓存配置
	setOptions(options) {
		// remove old accessor
		Object.keys(this._cache).forEach(key => delete this[key])
		// rebuild
		this.init(Object.assign({}, this.options, options))
	},
})

// static
DataCache.options = {
	// 跟路径
	rootPath: "root",

	// 全局缓存配置
	rootCache: {},

	// 用户id解析
	resolveUserId() {
		return ''
	},
}

const prefix = "route_"

// 从路由对象创建
DataCache.fromRoute = function(route) {
	return new DataCache({
		cache: route.meta && route.meta.cache || {},
		path: prefix + route.path,
		query: route.query
	})
}

export default DataCache